import React, { useState, useEffect } from "react";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import {
  Grid,
  Dimmer,
  Divider,
  Button,
  Icon,
  Confirm,
  Form,
} from "semantic-ui-react";
import * as deliveryAddressReducer from "../Profile/DeliveryAddress/deliveryAddress.reducer";
import Loader from "../../components/Loader";
import "./deliveryAddress.css";
import Autocomplete from "react-google-autocomplete";
import "./deliveryAddress.css";
import AddressDetails from "../../components/AddressDetails";
import { Segment } from "semantic-ui-react";
import { showSuccessToast, showErrorToast } from "../../utils/toastUtils";
import _ from "lodash";
import MetaData from "../../components/MetaData";
import { allcCountryList } from "../../constants/appConstants";
import {
  apiCreateAccountDeliveryAddress,
  apiDeleteDeliveryAddress,
  apiSetDefaultAddress,
} from "./deliveryAddress.api";

const ManageAddress = (props) => {
  const [address, setAddress] = useState(null);
  const [loading, setLoading] = useState(false);
  const [customInput, setCustomInput] = useState("");
  const [placeName, setPlaceName] = useState("");
  const [confirmDelete, setConfirmDelete] = useState(false);
  const [itemToDelete, setItemToDelete] = useState(null);
  const [loadingText, setLoadingText] = useState("Please wait");

  useEffect(() => {
    getAllAddress();
  }, []);

  const goBack = () => {
    props.onCloseManageAddress();
  };

  const getAllAddress = () => {
    const allAddress = props.allAddress;
    return allAddress;
  };

  const updateDbCall = async (allAddress) => {
    setLoading(true);
    await props.actionUpdateDeliveryAddress({ deliveryAddress: allAddress });
    await props.actionGetAccountDetails();
    setLoading(false);
  };

  const isAddressValid = (newAddress) => {
    if (!newAddress.street.trim() && !newAddress.postalCode.trim()) {
      showErrorToast("Enter more details in your address. Eg Street Number");
      return false;
    }
    const deliveryAddress = getAllAddress();
    const b = _.pick(newAddress, ["street", "postalCode"]);
    const filteredAddress = _.filter(deliveryAddress, (address) => {
      const a = _.pick(address, ["street", "postalCode"]);
      return _.isEqual(a, b);
    });
    if (filteredAddress.length > 0) {
      showErrorToast("Duplicate address.");
      return false;
    }
    return true;
  };

  const clearAddress = () => {
    setAddress(null);
    setCustomInput("");
    setPlaceName("");
  };

  const addAddressHandler = async (newAddress, countries, states) => {
    if (!isAddressValid(newAddress)) return;

    newAddress.name = placeName;
    const allAddress = getAllAddress() || [];
    newAddress.isPrimary = allAddress.length === 0;

    console.log(newAddress);

    const addressData = {
      name: newAddress.name,
      street: newAddress.street,
      street2: newAddress.street2,
      suburb: newAddress.suburb,
      city: newAddress.city,
      state: newAddress.state,
      country: newAddress.country?.name,
      zipCode: newAddress.zip,
    };

    setLoading(true);
    const result = await apiCreateAccountDeliveryAddress(addressData);
    if (result) {
      showSuccessToast(
        <div>
          <Icon name="address book" /> Address added
        </div>
      );
    } else {
      showErrorToast("Something went wrong, please try again");
    }
    clearAddress();
    await props.getAddresses();
    getAllAddress();
    setLoading(false);
  };

  const deleteAddressHandler = (id, sfId) => {
    const allAddress = props.allAddress;
    const addressToBeDeleted = allAddress[id];
    if (addressToBeDeleted.isPrimary) {
      showErrorToast(
        "Cannot delete a default address. Change the Default and then delete."
      );
      return;
    }
    setConfirmDelete(true);
    setItemToDelete(addressToBeDeleted.id);
  };

  const deleteAddress = async () => {
    setLoading(true);
    setConfirmDelete(false);
    setItemToDelete(null);
    const result = await apiDeleteDeliveryAddress(itemToDelete);
    console.log(result);
    if (result) {
      showSuccessToast(
        <div>
          <Icon name="address book" /> Address deleted
        </div>
      );
    }
    await props.getAddresses();
    getAllAddress();
    setLoading(false);
  };

  const makePrimaryAddressHandler = async (addressId) => {
    props.allAddress.map((address) => {
      address.isDefault = false;
    });
    let defaultAdress = props.allAddress.find((item) => item.id === addressId);
    setLoading(true);
    defaultAdress.isDefault = true;
    await apiSetDefaultAddress(
      props.isDelivery ? addressId : null,
      !props.isDelivery ? addressId : null
    );
    await props.changeAddressHandler(defaultAdress);
    showSuccessToast(
      <div>
        <Icon name="truck" /> Default {props.isDelivery ? "Delivery" : "Pickup"}{" "}
        Address changed{" "}
      </div>
    );
    goBack();
  };

  const changeAddressHandler = async (address) => {
    props.allAddress.map((address) => {
      address.isSelected = false;
    });
    let selectedAddress = props.allAddress.find(
      (item) => item.id === address.id
    );
    selectedAddress.isSelected = true;
    await props.changeAddressHandler(selectedAddress);
    showSuccessToast(
      <div>
        <Icon name="truck" /> {props.isDelivery ? "Delivery" : "Pickup"} Address
        changed{" "}
      </div>
    );
    goBack();
  };

  const getDeliveryAddress = (deliveryAddress) => {
    if (_.isEmpty(deliveryAddress)) return null;
    return deliveryAddress?.map((value, key) => (
      <Grid.Column
        width={props.isDelivery ? 5 : 3}
        className="address-column"
        key={key}
      >
        <AddressDetails
          isDelivery={props.isDelivery}
          index={key}
          address={value}
          options={true}
          deleteAddressHandler={deleteAddressHandler}
          makePrimary={makePrimaryAddressHandler}
          changeHandler={changeAddressHandler}
          // editContactInfo={editContactInfoHandler}
          hasSelect={props.hasSelect}
        />
      </Grid.Column>
    ));
  };

  const onAddressSelection = (place) => {
    let address = getCitySuburb(place);
    if (address.suburb === address.city) address.suburb = "";
    setAddress(address);
  };

  const getCitySuburb = (place) => {
    const address = {
      street_number: "",
      route: "",
      subLocality_level_1: "",
      locality: "",
      administrative_area_level_1: "",
      country: "",
      postal_code: "",
    };
    place.address_components.forEach((component) => {
      const types = component.types;
      if (types.includes("street_number"))
        address.street_number = component.long_name;
      if (types.includes("route")) address.route = component.long_name;
      if (types.includes("sublocality_level_1"))
        address.subLocality_level_1 = component.long_name;
      if (types.includes("locality")) address.locality = component.short_name;
      if (types.includes("administrative_area_level_1"))
        address.administrative_area_level_1 = component.long_name;
      if (types.includes("country")) address.country = component.long_name;
      if (types.includes("postal_code"))
        address.postal_code = component.long_name;
    });
    if (address.subLocality_level_1 === "")
      address.subLocality_level_1 = address.locality;
    return {
      street: address.street_number,
      street2: address.route,
      suburb: address.subLocality_level_1,
      city: address.locality,
      state: address.administrative_area_level_1,
      zip: address.postal_code,
      country: { name: address.country },
    };
  };

  const countryList = JSON.parse(localStorage.getItem("countries"));
  const deliveryAddress = props.allAddress;
  let _deliveryAddress = [];
  if (deliveryAddress?.length > 0) {
    deliveryAddress?.forEach((item) => {
      _deliveryAddress?.push({
        name: item.addressDetails.name,
        street: item.addressDetails.street,
        street2: item.addressDetails.street2,
        state: item.addressDetails.state,
        suburb: item.addressDetails.suburb,
        zip: item.addressDetails.zipCode,
        country: { name: item.addressDetails.country },
        city: item.addressDetails.city,
        isPrimary: item.isDefault,
        salesforceId: null,
        id: item.id,
        addressDistance: item.addressDistance
          ? Math.round(item.addressDistance)
          : 0,
      });
    });
  }
  const deliverAddressComponent = getDeliveryAddress(_deliveryAddress);

  return (
    <>
      <MetaData title="Delivery addresses" />
      {loading && (
        <Dimmer active inverted>
          <Loader text="Please wait" size="large" />
        </Dimmer>
      )}
      <Grid className="manage-address-container">
        <Grid.Column width={16}>
          <Button
            size="small"
            onClick={goBack}
            icon
            labelPosition="left"
            className="button-float"
          >
            <Icon name="left arrow" /> Go back
          </Button>
          <h3 className="address-title">
            <Icon name="address book" />{" "}
            {`${props.isDelivery ? "Delivery" : "Pickup"} Addresses`}
          </h3>
          <Divider />
        </Grid.Column>
        {props.isDelivery ? (
          <Grid.Column width={16} computer={6} mobile={16}>
            <label>
              <h4>Add new address</h4>
            </label>
            <div className="google-autocomplete-container">
              {!address && (
                <Form>
                  <Form.Field>
                    <Autocomplete
                      apiKey={process.env.REACT_APP_GOOGLE_MAPS_API_KEY}
                      required
                      style={{ width: "100%" }}
                      placeholder="Start typing your address"
                      className="input-box"
                      onPlaceSelected={onAddressSelection}
                      types={["geocode"]}
                      componentRestrictions={{ country: countryList }}
                    />
                  </Form.Field>
                </Form>
              )}
            </div>
            {address && (
              <Segment>
                <Form>
                  <Form.Field>
                    <input
                      type="text"
                      name="address"
                      placeholder="Enter place name (Optional)"
                      maxLength="40"
                      value={placeName}
                      onChange={(e) => setPlaceName(e.target.value)}
                    />
                  </Form.Field>
                </Form>
                <AddressDetails
                  isNew={true}
                  isDelivery={props.isDelivery}
                  address={address}
                  options={false}
                  add={true}
                  addHandler={addAddressHandler}
                  cancelHandler={clearAddress}
                  changeHandler={changeAddressHandler}
                />
              </Segment>
            )}
          </Grid.Column>
        ) : null}
        <Grid.Column width={props.isDelivery ? 10 : 16}>
          <Grid columns="equal" className="address-grid">
            {deliverAddressComponent}
          </Grid>
        </Grid.Column>
      </Grid>

      <Confirm
        className="delete-address"
        open={confirmDelete}
        cancelButton="Cancel"
        confirmButton="Delete"
        content="Are you sure you want to delete the address ? "
        onCancel={() => setConfirmDelete(false)}
        onConfirm={deleteAddress}
      />
    </>
  );
};

const mapStateToProps = (state) => {
  return {
    forms: state.forms,
    auth: state.auth,
    response: state.response,
  };
};

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(deliveryAddressReducer, dispatch);

export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(ManageAddress)
);
